module.exports = __webpack_public_path__ + "img/brief-icon.4bf0a37d.png";